import { JSONSchema7, JSONSchema7Type } from 'json-schema';
import JSONSchema7Properties from '../../../Shared/jSONSchema7Properties';
import { SelectOption } from '../types';

export default (currentVersion: JSONSchema7): JSONSchema7 => {
  const properties = currentVersion.properties as JSONSchema7Properties;

  properties['version'].default = 8;

  properties['options'].default = (
    properties['options'].default as unknown as SelectOption[]
  ).map((option) => {
    option.utilize = option.utilize
      ? option.utilize.replace(/,/g, "|")
      : option.utilize;
    return option;
  }) as unknown as JSONSchema7Type;

  return {
    ...currentVersion,
    properties
  };
};
